import {StatusInterface} from '../../@components'
import {useCallback, useState} from 'react'

interface FormState {
  loading: boolean;
  statusMessage: StatusInterface;
}

export const useStatusMessage = (timeout: number = 2500) => {

  const [formState, setFormState] = useState<FormState>({
    loading: false,
    statusMessage: {status: -1, color: '', icon: '', message: ''},
  })

  const handleStatusMessage = useCallback(
    ({status, message, color, icon}: StatusInterface) => {

      setFormState((prevState) => ({
        ...prevState,
        statusMessage: {status, message, color, icon},
      }))

      setTimeout(() => {
        setFormState((prevState) => ({
          ...prevState,
          statusMessage: {status: -1, message: '', color: '', icon: ''},
        }))
      }, timeout)
    },
    [timeout],
  )

  return {
    formState,
    setLoading: (loading: boolean) => setFormState(prevState => ({...prevState, loading})),
    handleStatusMessage,
  }
}